import './polyfills';
import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import ReactGA from "react-ga4";
import config from 'devextreme/core/config';

ReactGA.initialize("G-YZGCPWHZBL");

config({
  licenseKey: process.env.REACT_APP_DEVEXTREME_LICENSE_KEY
});

// React 18 uses createRoot instead of ReactDOM.render
const container = document.getElementById('root');
const root = createRoot(container);
root.render(<App />);

serviceWorker.unregister();